export const Days = [
  { id: 'mo', name: 'Lunes', day: 'monday' },
  { id: 'tu', name: 'Martes', day: 'thursday' },
  { id: 'we', name: 'Miércoles', day: 'wednesday'},
  { id: 'th', name: 'Jueves', day: 'tuesday' },
  { id: 'fr', name: 'Viernes', day: 'friday' },
  { id: 'sa', name: 'Sábado', day: 'saturday' },
];
